import React from "react";
import { Accordion, AccordionSet, Button, Checkbox, } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { RecekSelect } from "./inputs";
export var PublisherPrefixRangeFilters = function (_a) {
    var agencyPrefixesOptions = _a.agencyPrefixesOptions, agencyPrefixFilter = _a.agencyPrefixFilter, showClosedFilter = _a.showClosedFilter, onAgencyPrefixFilterChange = _a.onAgencyPrefixFilterChange, onShowClosedFilterChange = _a.onShowClosedFilterChange, onApplyFilters = _a.onApplyFilters;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement(AccordionSet, null,
        React.createElement(Accordion, { label: formatMessage({
                id: "ui-br-agency.publisher-prefix-range.accordion.title.filter",
            }), separator: false },
            React.createElement("form", { onSubmit: function (e) {
                    e.preventDefault();
                    onApplyFilters();
                } },
                React.createElement(RecekSelect, { labelId: "ui-br-agency.publisher-prefix-range.accordion.title.filter", name: "agency", value: agencyPrefixFilter, onChange: function (e) {
                        return onAgencyPrefixFilterChange(e.target.value);
                    } },
                    React.createElement("option", { value: "" }, formatMessage({
                        id: "ui-br-agency.collectionsList.select.option.all",
                    })),
                    agencyPrefixesOptions
                        .filter(function (option) { return option !== null; })
                        .map(function (option) { return (React.createElement("option", { key: option.id, value: option.id },
                        option.internationalPrefix.agency,
                        " ",
                        option.internationalPrefix.value,
                        "-",
                        option.value)); })),
                React.createElement(Checkbox, { label: formatMessage({
                        id: "ui-br-agency.publisher-prefix-range.show.closed",
                    }), name: "showClosed", checked: showClosedFilter, onChange: function (e) { return onShowClosedFilterChange(e.target.checked); } }),
                React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, type: "submit" }, formatMessage({ id: "ui-br-agency.button.apply" }))))));
};
